// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"L0-z","displaySixCardTiles":"M0-z"};